// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: var(--topbar-bg);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 100;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-container {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  width: 149px;
  height: 100%;
  object-fit: contain;
}

.top-bar-nav {
  display: flex;
  gap: 2rem;
  margin-left: 3rem;
}

.nav-link {
  text-decoration: none;
  transition: color 0.2s;
  padding: 0.5rem 0;
  color: white;
}

.nav-link:hover,
.nav-link.active {
  color: #3EB8CC;
}

.nav-link.active {
  border-bottom: 2px solid #3EB8CC;
}

.nav-link.disabled {
  color: var(--text-muted) !important;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}


.top-bar-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.add-leads-btn,
.top-bar-right .action-btn.chat {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  background: rgba(25, 73, 88, 0.4);
  border: 1px solid rgba(175, 220, 225, 0.6);
  border-radius: 6px;
  color: #3EB8CC;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
}

.add-leads-btn:hover:not(:disabled),
.top-bar-right .action-btn.chat:hover:not(:disabled) {
  background: rgba(25, 73, 88, 0.65);
  border-color: #3EB8CC;
  color: #5ce1e6;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(62, 184, 204, 0.2);
}

.add-leads-btn:disabled,
.top-bar-right .action-btn.chat:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}


.status-dot {
  width: 6px;
  height: 6px;
  background-color: var(--success-color);
  border-radius: 50%;
  box-shadow: 0 0 8px var(--success-color);
}

.user-profile {
  width: 52px;
  height: 46px;
  border: 1.3px solid #FFFFFF14;
  background: linear-gradient(270deg, #103106 0%, #1F4A10 91.25%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.85rem;
  color: white;
}

/* Profile Dropdown Styling */
.profile-container {
  position: relative;
}

.profile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 220px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease;
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-user-info {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 0.75rem;
}

.dropdown-username {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-main);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-role {
  font-size: 0.7rem;
  color: var(--text-secondary);
  margin-top: 2px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s ease;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--text-main);
}

.dropdown-item.logout {
  color: var(--secondary-accent);
}

.dropdown-item.logout:hover {
  background-color: rgba(255, 123, 84, 0.1);
  color: #ff8c6b;
}

/* Mobile Logout button inside drawer */
.mobile-logout-btn {
  display: none;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  padding: 0.75rem 1rem;
  background: rgba(255, 123, 84, 0.1);
  border: 1px solid rgba(255, 123, 84, 0.2);
  border-radius: 8px;
  color: var(--secondary-accent);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.mobile-logout-btn:hover {
  background: rgba(255, 123, 84, 0.2);
}

.mobile-menu-btn { display: none; color: white; background: transparent; border: none; cursor: pointer; padding: 0.5rem; outline: none; }
.mobile-close-btn { display: none; }
@media (max-width: 1024px) { .top-bar-nav { margin-left: 1.5rem; gap: 1.5rem; } }
@media (max-width: 768px) {
  .top-bar {         padding: 64px 16px 24px 16px; } 
  .tagline { display: none; } 
  .top-bar-nav { 
    display: flex; 
    position: fixed; 
    top: 0; 
    right: -100%; 
    left: auto; 
    bottom: 0; 
    width: 250px; 
    height: 100vh; 
    background-color: var(--topbar-bg); 
    flex-direction: column; 
    padding: 2rem 1rem; 
    margin-left: 0; 
    gap: 0; 
    border-bottom: none; 
    border-left: 1px solid var(--border-color); 
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.5); 
    z-index: 1001; 
    transition: right 0.3s ease-in-out; 
  } 
  .top-bar-nav.mobile-open { right: 0; } 
  .nav-link { width: 100%; padding: 1rem; border-bottom: 1px solid rgba(255, 255, 255, 0.05); } 
  .nav-link:last-child { border-bottom: none; } 
  .nav-link.active { border-bottom: 1px solid #3EB8CC; background: rgba(62, 184, 204, 0.05); } 
  .mobile-menu-btn { display: none; } 
  .mobile-close-btn { display: block; align-self: flex-end; color: white; background: transparent; border: none; cursor: pointer; padding: 0.5rem; outline: none; margin-bottom: 1rem; } 
  .hide-mobile { display: none; }
  .mobile-logout-btn {
    display: flex;
  }
}
@media (max-width: 480px) { .logo-img { width: 110px; } .top-bar-right { gap: 0.5rem; } .user-profile { width: 40px; height: 36px; } }
/* Notification System Styles */
.notification-container {
  position: relative;
  display: flex;
  align-items: center;
}

.notification-bell-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
}

.notification-bell-btn:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--text-main);
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #EF4444; /* Red badge */
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid var(--topbar-bg);
}

.notification-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: -50px;
  width: 340px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  overflow: hidden;
}

.notification-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.notification-header h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-main);
}

.notification-list {
  max-height: 380px;
  overflow-y: auto;
}

.notification-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-track {
  background: transparent;
}

.notification-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.notification-empty {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.notification-item {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.notification-item:hover {
  background-color: rgba(62, 184, 204, 0.05);
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification-icon-wrapper {
  background-color: rgba(62, 184, 204, 0.15);
  color: #3EB8CC;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-action {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-main);
}

.notification-item-body {
  padding-left: calc(24px + 0.5rem);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.notification-lead-name {
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.4;
}

.notification-priority {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
}

.priority-high {
  background-color: rgba(239, 68, 68, 0.15);
  color: #EF4444;
}

.priority-medium {
  background-color: rgba(245, 158, 11, 0.15);
  color: #F59E0B;
}

.priority-low {
  background-color: rgba(16, 185, 129, 0.15);
  color: #10B981;
}

.notification-item-footer {
  padding-left: calc(24px + 0.5rem);
  margin-top: 0.2rem;
}

.notification-time {
  font-size: 0.7rem;
  color: var(--text-muted);
}

/* Toast Styles */
.hitl-toast {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-left: 4px solid #3EB8CC;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;
  animation: slideInBottom 0.4s cubic-bezier(0.16, 1, 0.3, 1), slideOutBottom 0.3s ease-in 3.6s forwards;
  min-width: 320px;
  max-width: 400px;
  cursor: pointer;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
}

.toast-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toast-action {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-main);
}

.toast-body {
  padding-left: 32px;
}

.toast-lead-name {
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.4;
}

.toast-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  padding: 4px;
}

.toast-close:hover {
  color: var(--text-main);
}

@keyframes slideInBottom {
  from { transform: translateY(120%) scale(0.95); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes slideOutBottom {
  from { transform: translateY(0); opacity: 1; }
  to { transform: translateY(120%); opacity: 0; }
}

.brand-info {
  cursor: pointer;
}

.mobile-logout-icon {
  margin-right: 8px;
}

.upload-message-status {
  font-size: 14px;
  margin-right: 10px;
  font-weight: 500;
}

.upload-message-status.status-error {
  color: #DC2626;
}

.upload-message-status.status-success {
  color: #16A34A;
}

.hidden-file-input {
  display: none;
}

.notification-bell-btn.hitl-alert-unread {
  position: relative;
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.5);
  padding: 6px 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.notification-bell-btn.hitl-alert-read {
  position: relative;
  background-color: transparent;
  color: #94a3b8;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 6px 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.hitl-alert-text {
  font-weight: 600;
  font-size: 14px;
}

.notification-badge-topbar {
  position: absolute;
  top: -6px;
  right: -6px;
  border: 2px solid #000;
  font-size: 10px;
}

.user-profile {
  cursor: pointer;
}

.dropdown-role {
  text-transform: capitalize;
}

.notification-priority-toast {
  margin-left: auto;
}

`, "",{"version":3,"sources":["webpack://./src/styles/top-bar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,+DAA+D;EAC/D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB,aAAa,EAAE,YAAY,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,aAAa,EAAE;AACxI,oBAAoB,aAAa,EAAE;AACnC,6BAA6B,eAAe,mBAAmB,EAAE,WAAW,EAAE,EAAE;AAChF;EACE,mBAAmB,4BAA4B,EAAE;EACjD,WAAW,aAAa,EAAE;EAC1B;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,mBAAmB;IACnB,0CAA0C;IAC1C,0CAA0C;IAC1C,aAAa;IACb,kCAAkC;EACpC;EACA,2BAA2B,QAAQ,EAAE;EACrC,YAAY,WAAW,EAAE,aAAa,EAAE,kDAAkD,EAAE;EAC5F,uBAAuB,mBAAmB,EAAE;EAC5C,mBAAmB,gCAAgC,EAAE,oCAAoC,EAAE;EAC3F,mBAAmB,aAAa,EAAE;EAClC,oBAAoB,cAAc,EAAE,oBAAoB,EAAE,YAAY,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE;EACrL,eAAe,aAAa,EAAE;EAC9B;IACE,aAAa;EACf;AACF;AACA,4BAA4B,YAAY,YAAY,EAAE,EAAE,iBAAiB,WAAW,EAAE,EAAE,gBAAgB,WAAW,EAAE,YAAY,EAAE,EAAE;AACrI,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB,EAAE,cAAc;EACzC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sGAAsG;EACtG,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,OAAO,wBAAwB,EAAE,UAAU,EAAE;EAC7C,KAAK,2BAA2B,EAAE,UAAU,EAAE;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".top-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background-color: var(--topbar-bg);\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo-container {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-img {\n  width: 149px;\n  height: 100%;\n  object-fit: contain;\n}\n\n.top-bar-nav {\n  display: flex;\n  gap: 2rem;\n  margin-left: 3rem;\n}\n\n.nav-link {\n  text-decoration: none;\n  transition: color 0.2s;\n  padding: 0.5rem 0;\n  color: white;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: #3EB8CC;\n}\n\n.nav-link.active {\n  border-bottom: 2px solid #3EB8CC;\n}\n\n.nav-link.disabled {\n  color: var(--text-muted) !important;\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n\n.top-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.add-leads-btn,\n.top-bar-right .action-btn.chat {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 14px;\n  background: rgba(25, 73, 88, 0.4);\n  border: 1px solid rgba(175, 220, 225, 0.6);\n  border-radius: 6px;\n  color: #3EB8CC;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);\n  white-space: nowrap;\n}\n\n.add-leads-btn:hover:not(:disabled),\n.top-bar-right .action-btn.chat:hover:not(:disabled) {\n  background: rgba(25, 73, 88, 0.65);\n  border-color: #3EB8CC;\n  color: #5ce1e6;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(62, 184, 204, 0.2);\n}\n\n.add-leads-btn:disabled,\n.top-bar-right .action-btn.chat:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n\n.status-dot {\n  width: 6px;\n  height: 6px;\n  background-color: var(--success-color);\n  border-radius: 50%;\n  box-shadow: 0 0 8px var(--success-color);\n}\n\n.user-profile {\n  width: 52px;\n  height: 46px;\n  border: 1.3px solid #FFFFFF14;\n  background: linear-gradient(270deg, #103106 0%, #1F4A10 91.25%);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: white;\n}\n\n/* Profile Dropdown Styling */\n.profile-container {\n  position: relative;\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 220px;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  z-index: 1000;\n  animation: dropdownFadeIn 0.2s ease;\n  backdrop-filter: blur(12px) saturate(180%);\n  -webkit-backdrop-filter: blur(12px) saturate(180%);\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdown-user-info {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 0.75rem;\n}\n\n.dropdown-username {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-main);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown-role {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border-radius: 6px;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n}\n\n.dropdown-item:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: var(--text-main);\n}\n\n.dropdown-item.logout {\n  color: var(--secondary-accent);\n}\n\n.dropdown-item.logout:hover {\n  background-color: rgba(255, 123, 84, 0.1);\n  color: #ff8c6b;\n}\n\n/* Mobile Logout button inside drawer */\n.mobile-logout-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  margin-top: auto;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 123, 84, 0.1);\n  border: 1px solid rgba(255, 123, 84, 0.2);\n  border-radius: 8px;\n  color: var(--secondary-accent);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.mobile-logout-btn:hover {\n  background: rgba(255, 123, 84, 0.2);\n}\n\n.mobile-menu-btn { display: none; color: white; background: transparent; border: none; cursor: pointer; padding: 0.5rem; outline: none; }\n.mobile-close-btn { display: none; }\n@media (max-width: 1024px) { .top-bar-nav { margin-left: 1.5rem; gap: 1.5rem; } }\n@media (max-width: 768px) {\n  .top-bar {         padding: 64px 16px 24px 16px; } \n  .tagline { display: none; } \n  .top-bar-nav { \n    display: flex; \n    position: fixed; \n    top: 0; \n    right: -100%; \n    left: auto; \n    bottom: 0; \n    width: 250px; \n    height: 100vh; \n    background-color: var(--topbar-bg); \n    flex-direction: column; \n    padding: 2rem 1rem; \n    margin-left: 0; \n    gap: 0; \n    border-bottom: none; \n    border-left: 1px solid var(--border-color); \n    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.5); \n    z-index: 1001; \n    transition: right 0.3s ease-in-out; \n  } \n  .top-bar-nav.mobile-open { right: 0; } \n  .nav-link { width: 100%; padding: 1rem; border-bottom: 1px solid rgba(255, 255, 255, 0.05); } \n  .nav-link:last-child { border-bottom: none; } \n  .nav-link.active { border-bottom: 1px solid #3EB8CC; background: rgba(62, 184, 204, 0.05); } \n  .mobile-menu-btn { display: none; } \n  .mobile-close-btn { display: block; align-self: flex-end; color: white; background: transparent; border: none; cursor: pointer; padding: 0.5rem; outline: none; margin-bottom: 1rem; } \n  .hide-mobile { display: none; }\n  .mobile-logout-btn {\n    display: flex;\n  }\n}\n@media (max-width: 480px) { .logo-img { width: 110px; } .top-bar-right { gap: 0.5rem; } .user-profile { width: 40px; height: 36px; } }\n/* Notification System Styles */\n.notification-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.notification-bell-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.notification-bell-btn:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: var(--text-main);\n}\n\n.notification-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background-color: #EF4444; /* Red badge */\n  color: white;\n  font-size: 0.65rem;\n  font-weight: 700;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  border: 2px solid var(--topbar-bg);\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: -50px;\n  width: 340px;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  animation: dropdownFadeIn 0.2s ease;\n  backdrop-filter: blur(16px) saturate(180%);\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n  overflow: hidden;\n}\n\n.notification-header {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.notification-list {\n  max-height: 380px;\n  overflow-y: auto;\n}\n\n.notification-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notification-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.notification-list::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n.notification-empty {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.notification-item {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.notification-item:hover {\n  background-color: rgba(62, 184, 204, 0.05);\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.notification-icon-wrapper {\n  background-color: rgba(62, 184, 204, 0.15);\n  color: #3EB8CC;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-action {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.notification-item-body {\n  padding-left: calc(24px + 0.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.notification-lead-name {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.notification-priority {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n}\n\n.priority-high {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #EF4444;\n}\n\n.priority-medium {\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #F59E0B;\n}\n\n.priority-low {\n  background-color: rgba(16, 185, 129, 0.15);\n  color: #10B981;\n}\n\n.notification-item-footer {\n  padding-left: calc(24px + 0.5rem);\n  margin-top: 0.2rem;\n}\n\n.notification-time {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n}\n\n/* Toast Styles */\n.hitl-toast {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-left: 4px solid #3EB8CC;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  z-index: 9999;\n  animation: slideInBottom 0.4s cubic-bezier(0.16, 1, 0.3, 1), slideOutBottom 0.3s ease-in 3.6s forwards;\n  min-width: 320px;\n  max-width: 400px;\n  cursor: pointer;\n  backdrop-filter: blur(16px) saturate(180%);\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toast-action {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.toast-body {\n  padding-left: 32px;\n}\n\n.toast-lead-name {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.toast-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n  padding: 4px;\n}\n\n.toast-close:hover {\n  color: var(--text-main);\n}\n\n@keyframes slideInBottom {\n  from { transform: translateY(120%) scale(0.95); opacity: 0; }\n  to { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n@keyframes slideOutBottom {\n  from { transform: translateY(0); opacity: 1; }\n  to { transform: translateY(120%); opacity: 0; }\n}\n\n.brand-info {\n  cursor: pointer;\n}\n\n.mobile-logout-icon {\n  margin-right: 8px;\n}\n\n.upload-message-status {\n  font-size: 14px;\n  margin-right: 10px;\n  font-weight: 500;\n}\n\n.upload-message-status.status-error {\n  color: #DC2626;\n}\n\n.upload-message-status.status-success {\n  color: #16A34A;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.notification-bell-btn.hitl-alert-unread {\n  position: relative;\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.5);\n  padding: 6px 12px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n}\n\n.notification-bell-btn.hitl-alert-read {\n  position: relative;\n  background-color: transparent;\n  color: #94a3b8;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 6px 12px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n}\n\n.hitl-alert-text {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.notification-badge-topbar {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  border: 2px solid #000;\n  font-size: 10px;\n}\n\n.user-profile {\n  cursor: pointer;\n}\n\n.dropdown-role {\n  text-transform: capitalize;\n}\n\n.notification-priority-toast {\n  margin-left: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
